import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ColumnTable } from 'src/app/models/column-table';
import { Filter } from 'src/app/models/filter';
import { OrdersWithPendingInvoice } from 'src/app/models/order-with-pending-invoice';
import { Paging } from 'src/app/models/page';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { OrderService } from 'src/app/services/order.service';

@Component({
  selector: 'app-order-with-pending-invoice',
  templateUrl: './order-with-pending-invoice.component.html',
  styleUrls: ['./order-with-pending-invoice.component.sass']
})
export class OrderWithPendingInvoiceComponent implements OnInit {

  ordersWithPendingInvoice: Paging<OrdersWithPendingInvoice[]> = new Paging([]);
  //private resolve: (value: boolean) => any = (value: boolean) => { };

  constructor(private orderService: OrderService,
    private configurationService: ConfigurationService,
    private router: Router,
    private bsModalRef: BsModalRef
  ) { }

  ngOnInit(): void {
    //this.getOrderData({ page: 0, pageSize: 10, value: {} });
  }

  zeroPad(input: number, width: number) {
    return input.toLocaleString('en-US',
      {
        style: 'decimal',
        minimumIntegerDigits: width,
        useGrouping: false
      });
  }

  getTableColumns(): Array<ColumnTable> {

    return [
      new ColumnTable('_id', "Codigo"),
      new ColumnTable('salesOrg', "Sociedad"),
      new ColumnTable('branchCode', "Tienda"),
      new ColumnTable('status', "Estado", { type: "badge", valueMap: this.getStatusMap() }),
      new ColumnTable("timeStamp", "Fecha", { type: "date" })
    ];
  }

  private getStatusMap(): Map<string, string> {
    let result = new Map<string, string>();

    result.set("INITIAL", "Inicial");
    result.set("FINAL", "Facturado");
    result.set("INVOICEABLE", "Facturable");
    result.set("REJECTED", "Rechazado");

    return result;
  }

  async getData(filter: Filter<any>): Promise<void> {


    this.ordersWithPendingInvoice = (await this.orderService.readOrderWithPendingInvoice(
      filter,
      this.configurationService.readSelectedBranchAndSalesOrg().salesOrg.code,
      this.configurationService.readSelectedBranchAndSalesOrg().branch.code).toPromise()
    ).response;
  }

  exit() {
    this.bsModalRef.hide();
  }

  goToOrder(ordersWithPendingInvoice: OrdersWithPendingInvoice) {
    this.router.navigate(["orders", ordersWithPendingInvoice._id]);
    this.exit();
  }

}
